import { Injectable, signal } from '@angular/core';

const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private readonly _accessToken = signal<string | null>(this.loadFromStorage(ACCESS_TOKEN_KEY));
  private readonly _refreshToken = signal<string | null>(this.loadFromStorage(REFRESH_TOKEN_KEY));

  private loadFromStorage(key: string): string | null {
    if (typeof window === 'undefined') return null;
    return localStorage.getItem(key);
  }

  private saveToStorage(key: string, value: string): void {
    if (typeof window === 'undefined') return;
    localStorage.setItem(key, value);
  }

  private removeFromStorage(key: string): void {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(key);
  }

  getToken(): string | null {
    return this._accessToken();
  }

  setToken(token: string): void {
    this._accessToken.set(token);
    this.saveToStorage(ACCESS_TOKEN_KEY, token);
  }

  getRefreshToken(): string | null {
    return this._refreshToken();
  }

  setRefreshToken(token: string): void {
    this._refreshToken.set(token);
    this.saveToStorage(REFRESH_TOKEN_KEY, token);
  }

  clearTokens(): void {
    this._accessToken.set(null);
    this._refreshToken.set(null);
    this.removeFromStorage(ACCESS_TOKEN_KEY);
    this.removeFromStorage(REFRESH_TOKEN_KEY);
  }

  hasToken(): boolean {
    return this._accessToken() !== null;
  }
}
